import { z } from 'zod';
/**
 * Lowercase-only UUID regex (cycle-1 C2).
 *
 * Same constraint as `add-logo.schema.ts` — see that module for rationale.
 * Each element in the `order` array must be a lowercase UUID; uppercase or
 * mixed-case UUIDs are rejected at the HTTP boundary by this schema.
 */
const LOWERCASE_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
/**
 * Input schema for `PATCH /organizations/:slug/settings/logos/order`.
 *
 * `order` is an array of lowercase UUIDs. An empty array is valid —
 * it either clears all logos or represents a no-op reorder depending on
 * domain semantics. Minimum length is 0 (`.min(0)` is the default for
 * `z.array()` but is stated explicitly for clarity).
 *
 * `.strict()` rejects extra top-level keys so that callers cannot smuggle
 * additional fields past the validation boundary.
 */
export const reorderLogosSchema = z
    .object({
    order: z.array(z.string().regex(LOWERCASE_UUID)).min(0),
})
    .strict();
//# sourceMappingURL=reorder-logos.schema.js.map